import { notification } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { RevenueValues } from './revenue-values';
import { SubscriptionCounters } from './subscription-counters';
import { LatestSales } from './latest-sales';

export function OplevAltRoute(): JSX.Element {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (showError === true) {
			notification.error({ message: 'Netværks fejl', onClose: () => setShowError(false) });
		}
	}, [showError]);

	return (
		<Container className="dashboard-container">
			<img src='https://filer.oplevalt.dk/oplev-alt-logo_2.png' alt='OplevAlt logo' className='oplevalt-logo' />
			<SubscriptionCounters />
			<RevenueValues />
			<LatestSales />
		</Container>
	);
}

const Container = styled.main`
	padding-top: 60px;
	background-color: #1a202c;
	display: flex;
	flex-direction: column;

	.oplevalt-logo {
		position: absolute;
		top: 16px; 
		left: 16px; 
		width: 70px;
	}
`;
